import { render } from "./DonationCategoryManageCreateForm.vue?vue&type=template&id=4d411c7d&lang=true"
import script from "./DonationCategoryManageCreateForm.vue?vue&type=script&lang=js"
export * from "./DonationCategoryManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__